import { useContext, useEffect, useState } from "react";
import { Props } from "./AccordionDetailsProps";
import MainContext from "../../../context/mainContext";
import { ISummaryDraftModel } from "../../../models/summary.model";
import summaryService from "../../../services/summary.service";
import SpinnerArea from "../../../components/SpinnerArea";
import { Box } from "@mui/material";
import styles from "./AccordionDetails.module.scss";
import DocumentView from "../../../components/DocumentView";
import Empty from "./Empty";
import { t } from "i18next";

const SummaryDraft: React.FC<Props & { isFinal: boolean }> = ({ publicationId, isFinal, expanded }) => {
  const { service } = useContext(MainContext);
  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [draft, setDraft] = useState<ISummaryDraftModel>();

  useEffect(() => {
    let active = true;

    if (active && expanded && !loaded) {
      service(() => (isFinal ? summaryService.finalDraft(publicationId) : summaryService.draft(publicationId)), {
        loader: setLoading,
        callback: (data) => {
          setDraft(data);
          setLoaded(true);
        },
      });
    }

    return () => {
      active = false;
    };
  }, [expanded, loaded, publicationId, isFinal, service]);

  return (
    <SpinnerArea loading={loading}>
      {draft ? (
        <Box className={styles.draft}>
          <DocumentView document={draft} showVersion />
        </Box>
      ) : (
        <Empty messge={t("youDontHaveAnyDraftYet")} />
      )}
    </SpinnerArea>
  );
};

export default SummaryDraft;
